import React from "react";
import { displayDate, displayTime } from "../../Utils/formatDate";

const SurgeryInfoDisplay = ({ SurgeryFormData }) => {
  if (!SurgeryFormData) return null;

  const {
    first_name,
    last_name,
    dob,
    requested_date_of_surgery,
    requested_time_of_surgery,
  } = SurgeryFormData;

  return (
    <div className="my-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="font-medium">
            Patient Name: {first_name} {last_name}
          </label>
        </div>
        <div>
          <label className="font-medium">
            Date of Birth: {dob ? displayDate(dob) : ""}
          </label>
        </div>
        <div>
          <label className="font-medium">
            Date: {displayDate(requested_date_of_surgery)}
          </label>
        </div>
        <div>
          <label className="font-medium">
            Time: {displayTime(requested_time_of_surgery)}
          </label>
        </div>
      </div>
    </div>
  );
};

export default SurgeryInfoDisplay;
